import {createTheme} from '@mui/material/styles';
import typography from "./typography";

export const createAppTheme = (mode = 'light') => createTheme({
  palette: {
    mode,
    background: {
      default: mode === 'light' ? "#F3F6FF" : "#121212",
      paper: mode === 'light' ? "#fff" : "#1e1e1e",
    },
    primary: {
      main: mode === 'light' ? "#187BAC" : "#2a8ac0",
      contrastText: "#fff",
    },
    secondary: {
      main: mode === 'light' ? "#3DAF8C" : "#0e6c52",
      contrastText: "#fff",
    },
  },
  colorPreset: 'green',
  contrast: 'high',
  typography,
});

// Default light theme for backward compatibility
const theme = createAppTheme('light');

export default theme;
